import classnames from 'classnames';

import Button from 'monday-ui-react-core/dist/Button';
import Info from 'monday-ui-react-core/dist/icons/Info';
import Upgrade from 'monday-ui-react-core/dist/icons/Upgrade';
import Checkbox from 'monday-ui-react-core/dist/Checkbox';
import Tooltip from 'monday-ui-react-core/dist/Tooltip';
import IconComponent from '../../components/ui-components/icon/icon-component';

function DocumentBrandComponent({
                               removeMondayBrand,
                               canChangeDocumentBrandSetting,
                               onCheckboxChange,
                               onLabelClick,
                               onUpgradePlanClick,
                             }) {
  return (
    <div className={classnames('document-brand-component', { disabled: !canChangeDocumentBrandSetting })}>
      <div className="checkbox-wrapper">
        <Checkbox
          disabled={!canChangeDocumentBrandSetting}
          componentClassName="checkbox"
          checked={removeMondayBrand && canChangeDocumentBrandSetting}
          onChange={onCheckboxChange}
        />
      </div>
      <div className="content">
        <div className="checkbox-content">
          <div className="checkbox-label" onClick={canChangeDocumentBrandSetting ? onLabelClick : undefined}>
            Remove monday.com branding from your documents
            <Tooltip wrapperClassName="billing-document-brand-tooltip-wrapper" content="Available on the Pro plan and above" position="top">
              <div className="info-icon-wrapper">
                <IconComponent className="info-icon" icon={Info} secondary />
              </div>
            </Tooltip>
          </div>
        </div>
        {!canChangeDocumentBrandSetting && (
          <div className="upgrade-plan">
            <Button color={Button.colors.POSITIVE} onClick={onUpgradePlanClick}>
              <div className="upgrade-icon-wrapper">
                <IconComponent className="upgrade-icon" icon={Upgrade} />
              </div>
              Upgrade your plan
            </Button>
          </div>
        )}
      </div>
    </div>
  );
}

DocumentBrandComponent.defaultProps = {
  removeMondayBrand: false,
  canChangeDocumentBrandSetting: false,
  onCheckboxChange: () => {},
  onLabelClick: () => {},
  onUpgradePlanClick: () => {},
};

export default DocumentBrandComponent;
